import React from "react";
import {Helmet} from "react-helmet";
// import { Helmet, HelmetProvider } from 'react-helmet-async';
import pricingImg from "../../assets/pricing.jpeg";
// import founder from "../../assets/yoganta-founder-img.webp";
import RaushanYoganta from "../../assets/RaushanYoganta.jpg";
// import Tungasri from "../../assets/Tungasri.jpg";
import Nishi from "../../assets/Nishi-Nutritionist.webp";
import Kaavya from "../../assets/Kaavya.webp";
import Meena from "../../assets/Meena.webp";
// import Anjali from "../../assets/Anjali-singh.jpeg";
// import Yamuna from "../../assets/Yamuna-crop.webp";
// import Tanisha from "../../assets/tanisha.jpeg";
import Amrutha from "../../assets/amrutha.jpeg";
// import Chakradhar from "../../assets/Chakradhar.jpg";
import Shivam from "../../assets/ShivamKumar.jpg";
// import Umar from "../../assets/Umar.jpg";
// import Jahnavi from "../../assets/Jahnavi.jpg";
import Sravani from "../../assets/Sravani.PNG";
// import Gaurav from "../../assets/Gaurav.jpg";
// import Poorti from "../../assets/Poorti.jpg";
import Aasma from "../../assets/AasmaBegum.png";
import Jugnu from "../../assets/Jugnu_Pathak.png";
import Spandana from "../../assets/SpandanaPappula.png";
import "./About.css";
import PunchLine from "../commonComps/PunchLine";
import { NavLink } from "react-router-dom";

function About() {
	return (
		<div>
			{/* Metadata */}
				<Helmet>
					<title>About Us - Yoganta</title>
					<meta name="description" content="Welcome to Yoganta. we are here for you. To serve and support you on your path of self-discovery, to become the highest version of yourself, to step into your power and your full potential." />
					<link rel="canonical" href="https://www.yoganta.in/about"/>
					<meta name="robots" content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"/>
					<meta name="keywords" content="yoganta, yoganta Hyderabad, yoganta technologies private limited, Raushan Kumar, Raushan Yoganta, Yoganta founder, yoganta team" />
     			</Helmet>
    		{/* Metadata */}
			<section className="about-new-top">
				<div className="about-new-top-head">
					<h1 className="about-new-top-head-heading">Welcome to Yoganta</h1>
					<p className="about-new-top-head-para">
					We are here for you. To serve and support you on your path of self-discovery, 
					to become the highest version of yourself, to step into your power and your full potential.
					</p>
				</div>
			</section>

			<section className="about-new-second-sec">
				<div className="about-new-second-sec-div">
					<img className="about-new-second-sec-div-img" src={pricingImg} alt="img-cant-load" />
					<div className="about-new-second-sec-div-texts">
						<h3 className="about-new-second-sec-div-texts-title">Who We Are?</h3>
						<p className="about-new-second-sec-div-texts-para">
						Yoganta is a global wellness initiative founded by Raushan Yoganta, rooted in traditional Hatha Yoga. Our team of certified teachers and holistic therapists offers personalized yoga, healing, and wellness programs. We combine ancient wisdom with modern needs to help individuals live healthier, balanced lives - physically, mentally, and spiritually.
						</p>
					</div>
				</div>
			</section>

			<section className="about-new-third-sec">
				<div className="about-new-third-sec-main">
					<div className="about-new-third-sec-main-div">
						<h3 className="about-new-third-sec-main-div-title">Our Mission</h3>
						<p className="about-new-third-sec-main-div-para">
						To align indigenous yoga, alternative medicine with the mainstream health system.
						</p>
					</div>
					<div className="about-new-third-sec-main-div">
						<h3 className="about-new-third-sec-main-div-title">Our Vision</h3>
						<p className="about-new-third-sec-main-div-para">
						To be a one-stop holistic treatment provider for lifestyle diseases.
						</p>
					</div>
				</div>
			</section>

			<section className="about-new-fourth-sec">
				<div className="about-new-fourth-sec-main">
					<div className="about-new-fourth-sec-main-div-img">
						<img src={RaushanYoganta} alt="Yoganta founder Raushan Kumar aka Raushan Yoganta"></img>
					</div>
					<div className="about-new-fourth-sec-main-div">
						<h3 className="about-new-fourth-sec-main-div-title">Meet the Founder</h3>
						<br />
						<h4>Raushan Kumar</h4>
						<p>Founder & CEO, Yoganta</p> <hr/>
						{/* <p>Yoga Instructor | Sujok Therapist | Reiki Practitioner | Techie | Digital Marketer</p> */}
						<p className="about-new-fourth-sec-main-div-para">
							Better known as Raushan Yoganta, he is a dedicated Yoga Teacher, Reiki Practitioner, Sujok Therapist, Indie Author, and Digital Marketer. With over a decade of teaching experience, Raushan has guided individuals through personal sessions, group classes, corporate wellness programs, and online platforms, reaching students worldwide.
							<br/><br/> With a background in engineering and robotics, Raushan brings precision, structure, and clarity into his teaching. His own journey through stress and burnout led him to the healing path of yoga, which he now shares with a deep sense of authenticity and purpose.
						</p>
					</div>
				</div>
			</section>

			<section className="about-new-fifth-sec">
				<div className="about-new-fifth-sec-main">
					<div className="about-new-fifth-sec-main-title">Meet the Team</div>
					<div className="about-new-fifth-sec-main-div">
						{/* <div className="about-new-fifth-sec-main-div-card">
							<img src={Chakradhar} alt="Chakradhar Reddy" />
							<p>O. Chakradhar Reddy</p>
							<p>Cofounder & COO</p>
						</div> */}
						<div className="about-new-fifth-sec-main-div-card">
							<img src={Jugnu} alt="Jugnu Pathak Yoganta" />
							<p>Jugnu Pathak</p>
							<p>Cofounder & Head of Training</p>
						</div>
						<div className="about-new-fifth-sec-main-div-card">
							<img src={Shivam} alt="Yoganta Intern Shivam Kumar" />
							<p>Shivam Kumar</p>
							<p>Digital Intern</p>
						</div>
						<div className="about-new-fifth-sec-main-div-card">
							<img src={Aasma} alt="Yoganta Yoga Instructor Aasma Begum" />
							<p>Aasma Begum</p>
							<p>Yoga Instructor</p>
						</div>
						<div className="about-new-fifth-sec-main-div-card">
							<img src={Spandana} alt="Yoganta Yoga Instructor Spandana Pappula" />
							<p>Spandana Pappula</p>
							<p>Yoga Instructor</p>
						</div>
						<div className="about-new-fifth-sec-main-div-card">
							<img src={Amrutha} alt="Yoganta Yoga Trainer Amrutha Sharma" />
							<p>Amrutha Sharma</p>
							<p>Yoga Instructor</p>
						</div>
						<div className="about-new-fifth-sec-main-div-card">
							<img src={Meena} alt="Meena" />
							<p>Meena Jethi</p>
							<p>Reiki Master</p>
						</div>
						<div className="about-new-fifth-sec-main-div-card">
							<img src={Sravani} alt="Yoganta Yoga Trainer Sravani Reddy" />
							<p>Sravani Reddy</p>
							<p>Yoga Instructor</p>
						</div>
						<div className="about-new-fifth-sec-main-div-card">
							<img src={Nishi} alt="Nishi" />
							<p>Nishi Gupta</p>
							<p>Nutritionist</p>
						</div>
						{/* <div className="about-new-fifth-sec-main-div-card">
							<img src={Poorti} alt="Yoganta Content Writer Poorti Kaur" />
							<p>Poorti Kaur</p>
							<p>Content Writing</p>
						</div> */}
						{/* <div className="about-new-fifth-sec-main-div-card">
							<img src={Jahnavi} alt="Yoganta Yoga Trainer Sri Jahnavi" />
							<p>Sri Jahnavi</p>
							<p>Yoga Instructor</p>
						</div> */}
						
						<div className="about-new-fifth-sec-main-div-card">
							<img src={Kaavya} alt="Kaavya" />
							<p>Kaavya Yedla</p>
							<p>Yoga Instructor</p>
						</div>
						{/* <div className="about-new-fifth-sec-main-div-card">
							<img src={Anjali} alt="Anjali Singh Rathore" />
							<p>Anjali Singh Rathore</p>
							<p>Yoga Instructor</p>
						</div> */}
						
						{/* <div className="about-new-fifth-sec-main-div-card">
							<img src={maleAvatar} alt="img-cant-load" />
							<p>Arjun Ram</p>
							<p>Product Designer</p>
						</div>
						<div className="about-new-fifth-sec-main-div-card">
							<img src={femaleAvatar} alt="img-cant-load" />
							<p>Arjun Ram</p>
							<p>Product Designer</p>
						</div> */}
					</div>
				</div>
			</section>

			<section className="about-new-sixth-sec">
				<div className="about-new-sixth-sec-main">
					<div className="about-new-sixth-sec-main-div">
						<h3 className="about-new-sixth-sec-main-div-title">We’re hiring!</h3>
						<p className="about-new-sixth-sec-main-div-para">
						Make the best career move.
							<br />
							APPLY NOW
						</p>
					</div>
					<div className="about-new-sixth-sec-main-div">
						<NavLink to="/careers">
							<button type="button" className="career-btn">See the openings</button>
						</NavLink>
					</div>
				</div>
			</section>

			<PunchLine message="Helping You Find Peace Within Yourself" />
		</div>
	);
}

export default About;
